/* eslint-disable @typescript-eslint/no-unused-vars */
const pause = (duration) => new Promise((res) => setTimeout(res, duration));

// Applies back retry logic to a given function fn that is of type Promise
const withRetry = ({
  retries = 1,
  fn,
  delay = 500,
  backOffCoefficient = 2,
  onRetry = () => {},
  onFailed = (_err?: unknown) => {},
  onSuccess,
}) =>
  fn()
    .then((res) => onSuccess && onSuccess(res))
    .catch((err) =>
      retries > 0
        ? pause(delay).then(() => {
            if (onRetry) {
              onRetry();
            }

            return withRetry({
              retries: retries - 1,
              fn,
              delay: delay * backOffCoefficient,
              backOffCoefficient,
              onRetry,
              onFailed,
              onSuccess,
            });
          })
        : onFailed && onFailed(err)
    );

export default withRetry;
